export default () => document.documentElement.style.setProperty('--scroll-width', `${window.innerWidth - document.body.offsetWidth}px`);